<script setup lang="ts">
import { ref, onMounted } from 'vue';

const showBanner = ref(false);

const acceptCookies = () => {
  localStorage.setItem('cookieConsent', 'accepted');
  showBanner.value = false;
};

const declineCookies = () => {
  localStorage.setItem('cookieConsent', 'declined');
  showBanner.value = false;
};

onMounted(() => {
  // Check if user has already made a cookie consent choice
  const cookieConsent = localStorage.getItem('cookieConsent');
  if (!cookieConsent) {
    // If no choice has been made yet, show the banner
    showBanner.value = true;
  }
});
</script>

<template>
  <div v-if="showBanner" class="fixed bottom-0 left-0 right-0 bg-gray-800 text-white p-4 z-50">
    <div class="max-w-7xl mx-auto px-4">
      <div class="flex flex-col md:flex-row items-center justify-between gap-4">
        <div class="text-sm md:text-base">
          <p>We use cookies to enhance your experience on our website. By continuing to use this site, you consent to our use of cookies in accordance with our 
            <router-link to="/privacy" class="text-blue-400 hover:underline">Privacy Policy</router-link>.
          </p>
        </div>
        <div class="flex gap-3">
          <button 
            @click="declineCookies" 
            class="px-4 py-2 text-sm bg-transparent border border-gray-400 text-gray-200 rounded hover:bg-gray-700 transition-colors"
          >
            Decline
          </button>
          <button 
            @click="acceptCookies" 
            class="px-4 py-2 text-sm bg-green-600 text-white rounded hover:bg-green-700 transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
